import React from "react";
import { DmsPage, DmsAltBox, DmsTabber, intl } from "dmsbasereact";

import { TrainingsTab } from "./tabs/TrainingsTab";
import { MaterialsTab } from "./tabs/MaterialsTab";
import { GroupsTab } from "./tabs/GroupsTab";
import { VideosTab } from "./tabs/VideosTab";

export const TrainingCentralPage = () => {
    const tabs = [
        {
            title: intl.get("Trainings").d("Trainings"),
            component: <TrainingsTab />
        },
        {
            title: intl.get("TrainingMaterials").d("Training Materials"),
            component: <MaterialsTab />
        },
        {
            title: intl.get("TrainingGroups").d("Training Groups"),
            component: <GroupsTab />
        },
        {
            title: intl.get("TrainingPreview").d("Training Preview"),
            component: <VideosTab />
        }
    ];

    return (
        <DmsPage name={intl.get("TrainingManagement").d("Training Management")}>
            <DmsAltBox.Card>
                <DmsAltBox.Body>
                    <DmsTabber tabs={tabs} pageName={intl.get("TrainingManagement").d("Training Management")} />
                </DmsAltBox.Body>
            </DmsAltBox.Card>
        </DmsPage>
    );
};
